import {initializeApp} from 'firebase/app';
import {
  isDKHost,
  isFIHost,
  isNOHost,
  isProduction,
  isSEHost,
} from '../../config';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const getMeasurementId = () => {
  if (isSEHost) return 'G-E6T1PPTWQE';
  if (isNOHost) return 'G-XP64TFP36X';
  if (isDKHost) return 'G-ZXEHCB0FNH';
  if (isFIHost) return 'G-P55JV0YWDF';
  return 'G-JWRM7QQ91R';
};

const configProd = {
  apiKey: 'AIzaSyC9Vpk2UloF7DMMyVChF7Tpz0d247_C7-8',
  authDomain: 'resursbankapp.firebaseapp.com',
  databaseURL: 'https://resursbankapp.firebaseio.com',
  projectId: 'resursbankapp',
  storageBucket: 'resursbankapp.appspot.com',
  messagingSenderId: '1044999862742',
  appId: '1:1044999862742:web:e3d31d40403f93295acc77',
  measurementId: getMeasurementId(),
};

const configDev = {
  apiKey: 'AIzaSyD5Dvb3A9ghAQGSXMZNEBzXoKdKhxZFzDM',
  authDomain: 'resurssandbox.firebaseapp.com',
  databaseURL: 'https://resurssandbox.firebaseio.com',
  projectId: 'resurssandbox',
  storageBucket: 'resurssandbox.appspot.com',
  messagingSenderId: '690733612180',
  appId: '1:690733612180:web:bcfc877afb0c95c4bf0881',
  measurementId: 'G-9QRMWMP6DC',
};

const firebaseConfig = isProduction ? configProd : configDev;

const firebaseApp = initializeApp(firebaseConfig);

export {firebaseApp};
